query UserEntityMessageCounts($entityId: UUID!) {
  userEntityMessageCounts(entityId: $entityId) {
    totalMessages
    repliesReceived
    messagesReceived
    messagesSent
  }
}
